import React from 'react'
import '../css/site.css';

export default function OrderList() {
    //need to change this to take in an array for the custom orders and status like a state machine
    return(
        <div className="card-row no-wrap">
            <div className="purple-card">
                <h3>Status</h3>
                <p>Comissions: Open!
                    <br></br>
                    <br></br>
                    <img height="210px" src="images/ducktayto.png" alt="ducktayto personal growth"/>
                </p>
                <br></br>
            </div>
            <div className="card transparent">
                <h3>Currently Working on</h3>                
                <h4>Commissions</h4>
                <p> 1. Big mushroom boi (in-progress)
                    <br></br>
                    2. Open!
                </p>
                <h4>Upcoming Patterns</h4>
                <p>
                    TFT Dango (free)<br></br>
                    Fat Bean-Shaped Bird <br></br>
                    TFT Shork
                </p>
                <h4>Personal Projects</h4>
                <p>
                Camellia Sweater<br/>
                Freya Dress <br/>
                </p>
                <br></br>
            </div>
            <div className="card transparent">
                <h3>Recent Amigurumi</h3>
                <img className="card-img" src="images/gallery/bigmushroom.jpg" alt="big mushroom boy"/>
                <p>Big Mushroom Boy<br></br>
                2/28/25</p>
            </div>
            <div className="card transparent">
                <h3>Recent Outfit</h3>
                <img className="card-img" src="images/gallery/miku.jpg" alt="crochet flying miku dress"/>
                <p>Flying Miku<br></br>
                    2/15/24</p>
            </div>
        </div>
    );
}